export default __webpack_public_path__ + "static/media/culture-large.b76a8639.svg";